import "%blocks%/header/header.js";
import "%blocks%/footer/footer.js";